<template lang="html">
  <div class="agent-detail-info--inner">
    <info-wallet class="user-details-contents__items"></info-wallet>
    <info-memo class="user-details-contents__items"></info-memo>
  </div>
</template>

<script>
//= components
import Modal from '@/components/base/Modal'
import InfoWallet from '@/components/common/agent-details/InfoWallet'
import InfoMemo from '@/components/common/agent-details/InfoMemo'

export default {
  name: 'user-info',

  components: {
    Modal,
    InfoMemo,
    InfoWallet
  }
}
</script>
